import type { DealerResultType } from "../../../../common-deprecated/utils/dealerConstants";

export const USC_DEALER_INIT = "uscDealer/init";

type InitDealerType = { type: typeof USC_DEALER_INIT; dealer?: DealerResultType; failed: boolean };

export const initDealer = (dealer?: DealerResultType, failed = false): InitDealerType => ({
    type: USC_DEALER_INIT,
    dealer,
    failed,
});

export type UscDealerActionsType = InitDealerType;
